import { Suspense, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import LoadingFallback from '../LoadingFallback/LoadingFallback';

interface SuspenseOutletProps {
  fallback?: ReactNode;
  minHeight?: string | number;
  backgroundColor?: string;
}

const SuspenseOutlet = ({
  fallback,
  minHeight = 'calc(100vh - 80px)',
  backgroundColor = '#f6f9fb',
}: SuspenseOutletProps) => {
  const defaultFallback = (
    <LoadingFallback minHeight={minHeight} backgroundColor={backgroundColor} />
  );

  return (
    <Suspense fallback={fallback || defaultFallback}>
      <Outlet />
    </Suspense>
  );
};

export default SuspenseOutlet;
